import { InjectionToken } from '@angular/core';
import { DashboardRefreshMode } from '../recruiting/dashboard/enums/dashboard-refresh-mode.enum';

export class Settings {
    appName = '';
    domain = '';
    organizationId = 0;
    ayaWebAPIUrl = '';
    coreAPIUrl = '';
    ayacDomain = '';
    lotusOneDomain = '';
    supportEmail = '';

    /**
     * @deprecated - system no longer exists
     */
    crmDomain = '';

    webDomain = '';
    showNewMarginCalculator = true;
    showQuickQuoteButton = true;
    showUnrecommendJobButton = true;
    showRecommendJobButton = true;
    enableFeaturePolling = true;
    versionPollInterval = 300000;
    featurePollInterval = 300000;
    idleUserTimeout = 1000;
    dashboardActivityTimeoutMinutes = 15;

    dashboardRefreshMode = DashboardRefreshMode.SignalR;
    dashboardFollowupRefreshSeconds = 600;
    dashboardLeadRefreshSeconds = 180;
    dashboardHotRefreshSeconds = 30;
    dashboardLiveRefreshSeconds = 300;
    dashboardPreRefreshSeconds = 30;
    dashboardJobInterestSeconds = 300;
    dashboardWorRefreshSeconds = 600; // working tile refreshed less often than others, every 10mins
    dashboardTimeoutSeconds = 300;
    dashboardLiveTileTimeoutSeconds = 300;
    myAyaUrl = '';
    myAyaWebUrl = '';
    launchDarklyClientSdkKey = '';
    googleMapsKey = '';

    env = '';
    Datadog_Client_Token = '';
    Datadog_Service = '';
    Datadog_Client_TokenRum = '';
    Datadog_ApplicationId = '';

    authClientId = '';
    authDomain = '';
    authCacheLocation: 'memory' | 'localstorage' = 'localstorage';
    authDbConnection = '';
    authSsoConnection = '';
    redirectCallbackToHost = false;
}

export const APP_CONFIG = new InjectionToken<Settings>('app.config');
